let config = {
    "api_url": "https://jz8000.yaoyao.ink/v1",
    "logoText": "政务地图后台",
    "footerText": "荆州经济开发区",
    "copyright": "Copyright © 荆州经济开发区",
}
    // "backend_cas_valid_url": "http://210.42.150.134:8000",

export default config
